<template>
  <div class="mainPage">
    <div class="options">
      <div class="row">
        <div
          @click="(appointment = true), (contact = false)"
          class="home  col-md-2"
        >
          <div class="icon"></div>
        </div>
        <div
          @click="(appointment = true), (contact = false), (update = false)"
          class="appointment  col-md-3"
        >
          <div class="icon"></div>
          <div class="text">
            <h6>Life time access</h6>
            <p>The automated process all your website tasks.</p>
          </div>
        </div>

        <div
          @click="(contact = true), (appointment = false), (update = false)"
          class="contact col-md-3"
        >
          <div class="icon"></div>
          <div class="text">
            <h6>Life time access</h6>
            <p>The automated process all your website tasks.</p>
          </div>
        </div>
        <div
          @click="(update = true), (contact = false), (appointment = false)"
          class="update col-md-3"
        >
          <div class="icon"></div>
          <div class="text">
            <h6>Life time access</h6>
            <p>The automated process all your website tasks.</p>
          </div>
        </div>
      </div>
    </div>
    <div class="mainSection">
      <transition name="fade">
        <Appointment v-if="appointment == true"></Appointment>
        <Contact v-if="contact == true"></Contact>
        <Update v-if="update == true"></Update>
      </transition>
    </div>
  </div>
</template>

<script>
// import { db } from "../store/firebase";
// const documnetPath = 'clientapp/forms';
import Appointment from "./admin/appointment.vue";
import Contact from "./admin/contact.vue";
import Update from "./admin/update.vue";

export default {
  data() {
    return {
      appointment: false,
      contact: false,
      update: false,
    };
  },
  components: {
    Appointment,
    Contact,
    Update,
  },
};
</script>

<style lang="scss" scoped>

@import "../styles/_responsive.scss";

.mainPage {
  text-align: -webkit-center;
  height: 100%;
  min-height: 100vh;
  max-width: 100vw;
  padding-top: 63px;
  padding: 60px 20px;
  background-color: #ffffff;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 2000 1500'%3E%3Cdefs%3E%3Crect stroke='%23ffffff' stroke-width='0.49' width='1' height='1' id='s'/%3E%3Cpattern id='a' width='3' height='3' patternUnits='userSpaceOnUse' patternTransform='scale(25.15) translate(-960.24 -720.18)'%3E%3Cuse fill='%23fafafa' href='%23s' y='2'/%3E%3Cuse fill='%23fafafa' href='%23s' x='1' y='2'/%3E%3Cuse fill='%23f5f5f5' href='%23s' x='2' y='2'/%3E%3Cuse fill='%23f5f5f5' href='%23s'/%3E%3Cuse fill='%23f0f0f0' href='%23s' x='2'/%3E%3Cuse fill='%23f0f0f0' href='%23s' x='1' y='1'/%3E%3C/pattern%3E%3Cpattern id='b' width='7' height='11' patternUnits='userSpaceOnUse' patternTransform='scale(25.15) translate(-960.24 -720.18)'%3E%3Cg fill='%23ebebeb'%3E%3Cuse href='%23s'/%3E%3Cuse href='%23s' y='5' /%3E%3Cuse href='%23s' x='1' y='10'/%3E%3Cuse href='%23s' x='2' y='1'/%3E%3Cuse href='%23s' x='2' y='4'/%3E%3Cuse href='%23s' x='3' y='8'/%3E%3Cuse href='%23s' x='4' y='3'/%3E%3Cuse href='%23s' x='4' y='7'/%3E%3Cuse href='%23s' x='5' y='2'/%3E%3Cuse href='%23s' x='5' y='6'/%3E%3Cuse href='%23s' x='6' y='9'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='h' width='5' height='13' patternUnits='userSpaceOnUse' patternTransform='scale(25.15) translate(-960.24 -720.18)'%3E%3Cg fill='%23ebebeb'%3E%3Cuse href='%23s' y='5'/%3E%3Cuse href='%23s' y='8'/%3E%3Cuse href='%23s' x='1' y='1'/%3E%3Cuse href='%23s' x='1' y='9'/%3E%3Cuse href='%23s' x='1' y='12'/%3E%3Cuse href='%23s' x='2'/%3E%3Cuse href='%23s' x='2' y='4'/%3E%3Cuse href='%23s' x='3' y='2'/%3E%3Cuse href='%23s' x='3' y='6'/%3E%3Cuse href='%23s' x='3' y='11'/%3E%3Cuse href='%23s' x='4' y='3'/%3E%3Cuse href='%23s' x='4' y='7'/%3E%3Cuse href='%23s' x='4' y='10'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='c' width='17' height='13' patternUnits='userSpaceOnUse' patternTransform='scale(25.15) translate(-960.24 -720.18)'%3E%3Cg fill='%23e5e5e5'%3E%3Cuse href='%23s' y='11'/%3E%3Cuse href='%23s' x='2' y='9'/%3E%3Cuse href='%23s' x='5' y='12'/%3E%3Cuse href='%23s' x='9' y='4'/%3E%3Cuse href='%23s' x='12' y='1'/%3E%3Cuse href='%23s' x='16' y='6'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='d' width='19' height='17' patternUnits='userSpaceOnUse' patternTransform='scale(25.15) translate(-960.24 -720.18)'%3E%3Cg fill='%23ffffff'%3E%3Cuse href='%23s' y='9'/%3E%3Cuse href='%23s' x='16' y='5'/%3E%3Cuse href='%23s' x='14' y='2'/%3E%3Cuse href='%23s' x='11' y='11'/%3E%3Cuse href='%23s' x='6' y='14'/%3E%3C/g%3E%3Cg fill='%23e0e0e0'%3E%3Cuse href='%23s' x='3' y='13'/%3E%3Cuse href='%23s' x='9' y='7'/%3E%3Cuse href='%23s' x='13' y='10'/%3E%3Cuse href='%23s' x='15' y='4'/%3E%3Cuse href='%23s' x='18' y='1'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='e' width='47' height='53' patternUnits='userSpaceOnUse' patternTransform='scale(25.15) translate(-960.24 -720.18)'%3E%3Cg fill='%236b2b00'%3E%3Cuse href='%23s' x='2' y='5'/%3E%3Cuse href='%23s' x='16' y='38'/%3E%3Cuse href='%23s' x='46' y='42'/%3E%3Cuse href='%23s' x='29' y='20'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='f' width='59' height='71' patternUnits='userSpaceOnUse' patternTransform='scale(25.15) translate(-960.24 -720.18)'%3E%3Cg fill='%236b2b00'%3E%3Cuse href='%23s' x='33' y='13'/%3E%3Cuse href='%23s' x='27' y='54'/%3E%3Cuse href='%23s' x='55' y='55'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='g' width='139' height='97' patternUnits='userSpaceOnUse' patternTransform='scale(25.15) translate(-960.24 -720.18)'%3E%3Cg fill='%236b2b00'%3E%3Cuse href='%23s' x='11' y='8'/%3E%3Cuse href='%23s' x='51' y='13'/%3E%3Cuse href='%23s' x='17' y='73'/%3E%3Cuse href='%23s' x='99' y='57'/%3E%3C/g%3E%3C/pattern%3E%3C/defs%3E%3Crect fill='url(%23a)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23b)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23h)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23c)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23d)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23e)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23f)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23g)' width='100%25' height='100%25'/%3E%3C/svg%3E");
  background-attachment: fixed;
  background-size: cover;
  .options {
    display: flex;
    justify-content: center;
    margin-bottom: 50px;
    .contact,
    .appointment,
    .update,
    .home {
      width: 300px;
      height: 100px;
      margin: 20px;
      background: #2d3133;
      color: white;
      padding: 15px;
      border-radius: 10px;
      -webkit-box-shadow: 10px 9px 23px -2px rgba(0, 0, 0, 1);
      -moz-box-shadow: 10px 9px 23px -2px rgba(0, 0, 0, 1);
      box-shadow: 10px 9px 23px -2px rgba(0, 0, 0, 1);
      -webkit-transition: all 0.5s ease-in-out;
      translate: 2s;
      cursor: pointer;
      @media #{$large_tablet} {
          max-width: 95px;
          margin: 2vw;
        }
      .icon {
        height: 100%;
        float: left;
        margin-right: 8px;
        width: 30%;
        left: 0;
        max-width: 30%;
        background-repeat: no-repeat;
        background-size: contain;
         @media #{$large_tablet} {
          width: 80px;
          max-width: 100%;
          float: none;
          height: 80px;
          margin-right: 0;
        }
      }
      .text {
        p {
          font-size: 14px;
          font-weight: 300;
          line-height: 18px;
          color: #afafaf;
        }
        @media #{$large_tablet} {
          display: none;
        }
      }
      &:hover {
        box-shadow: none;
        transform: scale(0.97);
      }
    }
    .home {
      max-width: 93px;
      .icon {
        height: 100%;
        margin-right: 8px;
        width: 100%;
        max-width: 100%;
        background-repeat: no-repeat;
        background-size: contain;
         @media #{$large_tablet} {
          display: none;
        }
      }
    }
    .contact {
      .icon {
        background-image: url("../img/icons/contact.svg");
      }
    }
    .home {
      .icon {
        background-image: url("../img/icons/home.svg");
      }
    }
    .appointment {
      .icon {
        background-image: url("../img/icons/appointment.svg");
      }
    }
    .update {
      .icon {
        background-image: url("../img/icons/update.svg");
      }
    }
  }
}

.mainSection {
  background: #454d55;
  padding: 20px;
  max-width: 1100px;
  border-radius: 10px;
  -webkit-box-shadow: 10px 9px 23px -2px rgba(0, 0, 0, 1);
  -moz-box-shadow: 10px 9px 23px -2px rgba(0, 0, 0, 1);
  box-shadow: 10px 9px 23px -2px rgba(0, 0, 0, 1);
  overflow: auto;
  min-height: 500px;

}

</style>
